interface MobileTableViewProps<T> {
  data: T[];
  renderCard: (item: T, index: number) => React.ReactNode;
  emptyMessage?: string;
}

export function MobileTableView<T>({ 
  data, 
  renderCard, 
  emptyMessage = "No data available" 
}: MobileTableViewProps<T>) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-foreground-tertiary">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className=" ">
      {data.length > 0 && data?.map((item, index) => renderCard(item, index))}
    </div>
  );
}